
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export const MobileMenu: React.FC<MobileMenuProps> = ({ isOpen, onClose }) => {
  // Close menu on escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      // Prevent body scroll when menu is open
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-neutral-900/50 backdrop-blur-sm z-40 animate-fade-in"
        onClick={onClose}
        aria-hidden="true"
      />
      
      {/* Mobile Menu Panel */}
      <div className="fixed top-16 right-0 h-[calc(100vh-4rem)] w-80 max-w-[85vw] bg-white border-l border-neutral-200 shadow-brand-lg z-50 animate-slide-in-right">
        <div className="flex flex-col h-full">
          {/* Navigation Links */}
          <nav className="flex-1 px-6 py-8 space-y-6">
            <div className="space-y-4">
              <Link 
                to="/acerca-de" 
                className="block text-body-lg font-medium text-brand-primary hover:text-brand-primary-hover transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-brand-primary focus:ring-offset-2 px-3 py-3 rounded-md hover:bg-neutral-50 hover:-translate-x-1 hover:shadow-sm"
                onClick={onClose}
              >
                Acerca de
              </Link>
              <Link 
                to="/#caracteristicas" 
                className="block text-body-lg font-medium text-brand-primary hover:text-brand-primary-hover transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-brand-primary focus:ring-offset-2 px-3 py-3 rounded-md hover:bg-neutral-50 hover:-translate-x-1 hover:shadow-sm"
                onClick={onClose}
              >
                Características
              </Link>
              <Link 
                to="/precios" 
                className="block text-body-lg font-medium text-brand-primary hover:text-brand-primary-hover transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-brand-primary focus:ring-offset-2 px-3 py-3 rounded-md hover:bg-neutral-50 hover:-translate-x-1 hover:shadow-sm"
                onClick={onClose}
              >
                Precios
              </Link>
              <a 
                href="#faq" 
                className="block text-body-lg font-medium text-brand-primary hover:text-brand-primary-hover transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-brand-primary focus:ring-offset-2 px-3 py-3 rounded-md hover:bg-neutral-50 hover:-translate-x-1 hover:shadow-sm"
                onClick={onClose}
              >
                FAQ
              </a>
            </div>
          </nav>

          {/* Auth Buttons */}
          <div className="px-6 py-6 border-t border-neutral-200 space-y-4">
            <Link to="/login" onClick={onClose} className="block">
              <Button 
                variant="outline" 
                className="w-full border-2 border-neutral-300 hover:border-brand-primary hover:bg-neutral-50 transition-all duration-200 hover:-translate-y-0.5 hover:shadow-sm justify-center"
              >
                Iniciar sesión
              </Button>
            </Link>
            <Link to="/signup" onClick={onClose} className="block">
              <Button className="w-full bg-brand-primary hover:bg-brand-primary-hover text-white shadow-brand hover:shadow-brand-lg transition-all duration-200 hover:-translate-y-0.5 justify-center">
                Empieza gratis
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};
